import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DashboardLayoutComponent } from 'src/app/shared/layout/dashboard-layout/component/dashboard-layout.component';
import { SideNavModule } from '../../side-nav/side-nav.module';
import { RouterModule } from '@angular/router';
import { TopNavModule } from 'src/app/shared/top-nav/top-nav.module';
import { PopupWrapperModule } from 'src/app/kernel/popups/popup-wrapper/popup-wrapper.module';

@NgModule({
  declarations: [
    DashboardLayoutComponent
  ],
  imports: [
    CommonModule,
    SideNavModule,
    RouterModule,
    TopNavModule,
    PopupWrapperModule
  ],
  exports:[DashboardLayoutComponent]
})
export class DashboardLayoutModule { }
